<app-breadcrumb [title]="'Feather Icons'" [items]="['Icons']" [active_item]="'Feather Icons'"></app-breadcrumb>
  <!-- Container-fluid starts-->
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <h5 class="m-b-0">Feather Icons</h5>
          </div>
          <div class="card-body">
            <div class="row icon-lists feather-icons">
              <div class="col-12 col-sm-6 col-xl-4"  *ngFor="let icon of feather_icons" (click)="toggleWithInfo(icon)">
                <div class="media"><app-feather-icons [icon]=icon></app-feather-icons>
                  <div class="media-body align-self-center">
                    <h6 class="mt-0">{{icon}}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Container-fluid Ends-->
  <!-- On Item click display and copy icon code -->
  <div class="icon-hover-bottom p-fixed" *ngIf="detail">
    <div class="container-fluid">
      <div class="row">
        <div class="icon-popup">      
          <div class="close-icon"><i class="icofont icofont-close" (click)="detail=false"></i></div>
          <div class="icon-first"><i class="{{ficon}} fa-2x"></i></div>
          <div class="icon-class">
            <label class="icon-title">Class</label><span id="fclass1">{{ficon}}</span>
          </div>
          <div class="icon-last icon-last">
            <label class="icon-title">Markup </label>
            <div class="form-inline">
              <div class="form-group ">
                <input class="inp-val form-control m-r-10" type="text" value="{{val}}" readonly="readonly">
                <button class="btn btn-primary" (click)="copyText(ficon)" >Copy text</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>